import * as React from 'react';
import {Helmet} from 'react-helmet';
// @ts-expect-error
import {Redirect, ContextRouter} from 'react-router-dom';

import {colors} from 'shells/colors/colors';
import {headTitle} from 'shells/document/head-title';
import {PreAuthLayout} from 'shells/layout/pre-auth-layout';

import {JoinYourTeam} from './join-your-team';

export class JoinYourTeamPage extends React.Component<ContextRouter> {
    render() {
        const {location} = this.props;

        return (
            <PreAuthLayout
                backgroundColor={colors.navyLt}
                imageLeft={<img alt='' src='/include/images/auth/team.svg' />}
            >
                <Helmet>
                    <title>{headTitle('Join your team')}</title>
                </Helmet>
                {location && location.state && location.state.email ? (
                    <JoinYourTeam email={location.state.email} name={location.state.name} />
                ) : (
                    // @ts-expect-error
                    <Redirect to={{path: '/signup'}} />
                )}
            </PreAuthLayout>
        );
    }
}
